var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],staticClass:"char-count"},[_c('span',{class:_vm.klass},[_c('small',[_vm._v("You have "+_vm._s(_vm.charsLeft)+" of "+_vm._s(_vm.maxLength)+" characters remaining")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }